import { Tooltip, OverlayTrigger } from "react-bootstrap"
import { Placement } from "react-bootstrap/esm/types"

interface Props {
    title: string
    classNames?: string
    placement?: Placement
    children: any
}

export default function ToolTip({ title, classNames, placement, children } : Props) {
    return (
        <OverlayTrigger
            placement={placement ?? "top"}
            overlay={(props) => (
                <Tooltip {...props} className={classNames}>
                    {title}
                </Tooltip>
            )}
        >
            {children}
        </OverlayTrigger>
    )
}
